<div class="viewport-1" [style.background-image]="'url(' + taskBackgroundImage + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="totalTaskPoints"></task-bar>

  <div class="task-screen-element find-the-rhyme-container"
    [style.background-image]="' ' + taskContainerColor + ' '"
    [class]="(animationComplete) ? 'taskShow' : 'taskHide'">
    <button class="replayVideo-no-timerbar" (click)="replayVideo()" [disabled]="disableVideo()"></button>
    <div class="word-to">
      <div class="word font-42">
        {{targetWord}}
      </div>
    </div>
    <div class="response-row">
      @if (!unmaskedTask) {
        <button
          [class]="{'next-button-grayed' : disableNextButton, 'next-button' : !disableNextButton, 'toggle-next-on' : toggleNextButton, 'next-button-hidden': hideNextButton}"
          [disabled]="disableNextButton" (click)="displayTrial()">
        </button>
      }
    </div>
    @if (!hideResponses) {
      <div class="full-response-row">
        @for (response of responseOptions1; track $index) {
          <div class="button-div">
            <button [class]="(disableResponseButtons) ? 'rhyme-response-block-grayed font-30' : 'rhyme-response-block font-30'"
              (click)="submitAnswer($index)"
              [style.border-color]="' ' + highlightColor + ' '" [disabled]="disableResponseButtons">
              {{response}}
            </button>
          </div>
        }
      </div>
    }
    @if (!hideResponses) {
      <div class="full-response-row">
        @for (response of responseOptions2; track $index) {
          <div class="button-div">
            <!--TODO: adding to the index hardcoded could make for an easy mistake later, should probably
            update that, or at least make a constant. This happens in some other tasks too-->
            <button [class]="(disableResponseButtons) ? 'rhyme-response-block-grayed font-30' : 'rhyme-response-block font-30'"
              (click)="submitAnswer($index + 3)"
              [style.border-color]="' ' + highlightColor + ' '" [disabled]="disableResponseButtons">
              {{response}}
            </button>
          </div>
        }
      </div>
    }
  </div>
  <trial-counter [showCorrectIncorrect]="false" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTrialData()"></save-data-dialog>
</div>
